import etlApi from 'resources/etlApi';

export const exportProducts = ({ queries = {}, async = false } = {}) =>
  etlApi.ProductsExport(queries, async);

export const exportDesiredProducts = () => {
  return etlApi.DesiredProductsExport();
};
